import { TooltipProps } from '@approvalmax/ui/src/components/Tooltip/Tooltip.types';

export const openSectionsStorageKey = 'drawerOpenSections';

export const tooltipProps: Pick<TooltipProps, 'placement'> = { placement: 'right' };
